import { api } from 'shared/api/client';
import { apiErrorText } from 'shared/api/error-message';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { UUID } from './types';
import { dispatchMessage, EventType } from 'shared/feedback/toasts';
import { i18n } from 'shared/i18n';

export interface CreateTypedMemberValueRequest {
  documentSuperId: number;
  axisConceptId: UUID;
  value: string;
}

export interface CreatedTypedMemberValue {
  id: UUID;
  axisConceptId: UUID;
  value: string;
}

export function useCreateTypedMemberValue(): UseMutationResult<CreatedTypedMemberValue, unknown, CreateTypedMemberValueRequest> {
  return useMutation({
    mutationFn: async (input: CreateTypedMemberValueRequest) => {
      const res = await api.POST('/typed-member-values/', { body: input });
      return res?.data;
    },

    onError: (error: unknown) => {
      const message = apiErrorText(error, i18n('tag:dimensions.typed-value-save-error'));
      dispatchMessage(EventType.ADD_MESSAGE, { type: 'error', text: message, removeTime: 4000 });
    },
  });
}
